import { useEffect } from 'react';
import { LoadingIndicator } from '@arc/frontend/ui-graphics';
import { useAuthSafe, useRedirectToLogin } from '@arc/frontend/util-auth';
export function RequireLogin({
  children
}) {
  const {
    status
  } = useAuthSafe();
  const redirectToLogin = useRedirectToLogin();
  useEffect(() => {
    if (status === 'logged-out') {
      redirectToLogin();
    }
  }, [redirectToLogin, status]);
  return status === 'logged-in' ? children : <LoadingIndicator />;
}